import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbstractFormComponent, FieldDateComponent, FieldNumberComponent, FieldTextAreaComponent, FieldTextComponent, FieldSelectComponent, FieldDropdownComponent, LabelComponent, FieldWrapperComponent } from '@spike/scaffolds';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, of, startWith, switchMap } from 'rxjs';
import { Select } from "primeng/select";
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-shipping-form',
  providers:[],
  imports: [ReactiveFormsModule, CommonModule, FormsModule, FieldDateComponent, FieldTextAreaComponent, FieldTextComponent, FieldNumberComponent, FieldSelectComponent, OrganizationListComponent, Select, FieldWrapperComponent],
  templateUrl: './position-shipping-form.html'
})
export class PositionShippingFormComponent extends AbstractFormComponent{
  public readonly organizationStore = inject(OrganizationStoreService);

  public vehicleEtiquetteApi = EtiquetteApiEnum.VEHICLE;
  public vehicleModelApi = ModelApiEnum.VEHICLE;
  public vehicleApi = EntityApiEnum.VEHICLE;
  public courierTypeList = [
    {id: 1, shortDescription: "Interno"},
    {id: 2, shortDescription: "Esterno"}
  ];

  // Signal che osserva il valore del controllo 'courierType'
  public readonly courierType = toSignal(
    toObservable(this.form).pipe(
      switchMap(control => {
        if (!control) return of(1); // Default se la form non esiste ancora
        const field = control.get('courierType');
        if (!field) return of(1);

        return field.valueChanges.pipe(
          startWith(field.value), // Prende il valore iniziale (es. dal database)
          distinctUntilChanged()
        );
      })
    ),
    { initialValue: 1 }
  );
  
}